import React from "react";
import { Analytics } from "@/lib/analyticsShim";

export const Input = React.forwardRef(function Input({ className = "", ...props }, ref) {
  return <input ref={ref} className={className} {...props} />;
});
